import { render, staticRenderFns } from "./AquamarinaLogo.vue?vue&type=template&id=bb844f68&scoped=true&"
var script = {}
import style0 from "./AquamarinaLogo.vue?vue&type=style&index=0&id=bb844f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb844f68",
  null
  
)

export default component.exports